import { createClient } from '@supabase/supabase-js';

// Use environment variables with fallback to current values for development
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || 'https://lyalkthhougmrajigkyc.supabase.co';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Imx5YWxrdGhob3VnbXJhamlna3ljIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTk1MjUwNjgsImV4cCI6MjA3NTEwMTA2OH0.uqdRVq5bdqD1AAVQ2j0SkUYwNagF2vpIgNqOGM6Rl0M';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
